import React from 'react';
import { useOverlay } from '../context/OverlayContext';
import { useTranslation } from '../context/LanguageContext';
import '../styles/BubbleToggle.css';

const BubbleToggle = () => {
  const { bubblesEnabled, toggleBubbles } = useOverlay();
  const { t } = useTranslation();

  return (
    <div className="bubble-toggle-container">
      <span className="toggle-label">{t('bubbles.label')}</span>
      <label className="toggle-switch" aria-label={t('bubbles.label')}>
        <input
          type="checkbox"
          checked={bubblesEnabled}
          onChange={toggleBubbles}
        />
        <span className="slider"></span>
      </label>
    </div>
  );
};

export default BubbleToggle;